import {
  createMaxLengthRule,
  REQUIRED_VALIDATION_RULE,
} from '@const/validation'
import Input, { InputProps } from '@organisms/Input'
import { FieldForRender, FieldParams } from '..'

type Params = {
  placeholder: string
  isLoading?: boolean
  big?: boolean
  componentProps?: InputProps
  maxLength?: number
} & FieldParams

const textField = (params: Params): FieldForRender => {
  const {
    label,
    placeholder,
    isRequired,
    isLoading = false,
    widthMultiplier = 1,
    componentProps: props,
    big = false,
    name,
    maxLength,
  } = params

  const componentProps: InputProps = {
    ...props,
    placeholder,
    big,
    isLoading,
    maxLength,
  }

  return {
    ...params,
    label: isRequired ? `${label}*` : label,
    rules: {
      ...createMaxLengthRule(maxLength),
      ...(isRequired ? REQUIRED_VALIDATION_RULE : { required: false }),
    },
    Component: Input,
    componentProps,
    widthMultiplier,
    emptyValue: '',
    id: name,
  }
}

export default textField
